var button = "button__button__-U-QJ";
var loading = "button__loading__4PMI0";
var icon = "button__icon__OodK0";
var buttonContainer = "button__buttonContainer__C6lTN";
var buttonText = "button__buttonText__nvCyD";
var buttonContent = "button__buttonContent__tVdQi";
var shortcut = "button__shortcut__OKjxS";
var md = "button__md__fgTCf";
var lg = "button__lg__oiEan";
var hug = "button__hug__sHi7n";
var fill = "button__fill__teOYe";
var secondary = "button__secondary__8YIhr";
var destructiveSecondary = "button__destructiveSecondary__dJTw3";
var primary = "button__primary__tP7NU";
var destructive = "button__destructive__EwVR5";
var signup = "button__signup__O-43y";
var inverse = "button__inverse__Qvjq6";
var ghost = "button__ghost__0pJzW";
var link = "button__link__5iZjR";
var destructiveLink = "button__destructiveLink__oQbdL";
var btnTextFadeOut = "button__btn-text-fade-out__rdc3o";
var spinnerContainer = "button__spinnerContainer__iQZMx";
var spinnerFadeIn = "button__spinner-fade-in__ljUOf";
var spinnerContent = "button__spinnerContent__I8pXg";
var loadingText = "button__loadingText__UK1Xy";
var wideSize = "button__wideSize__fyONU";
var largeWideSize = "button__largeWideSize__-YVn9";

export { btnTextFadeOut, button, buttonContainer, buttonContent, buttonText, destructive, destructiveLink, destructiveSecondary, fill, ghost, hug, icon, inverse, largeWideSize, lg, link, loading, loadingText, md, primary, secondary, shortcut, signup, spinnerContainer, spinnerContent, spinnerFadeIn, wideSize };
//# sourceMappingURL=button.module.css.js.map
